export const saveToClipboard = (text: string) => {
  if (navigator.clipboard) {
    navigator.clipboard.writeText(text).catch(err => {
      console.error("Failed to copy text to clipboard:", err)
    })
  }
}
